import { Component, Input, forwardRef, input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';
import { InputBase } from './input-base';
import { Observable } from 'rxjs';
import { LookupItem } from '../../models/lookup-item';
import { IKeyValue } from '../../data/Ikey-value';
import { OptionItem } from '../../data/option-item';
import { IVisaType } from '../../data/visa-type';
import { Person } from '../../data/person';
import { PersonOption } from '../../models/person-option';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent extends InputBase {
  @Input() options: OptionItem[] | PersonOption[] | null = null;
  @Input() override placeholder: string = '';
  @Input() lookupItems: LookupItem[] | null = null;
  @Input() useLookupIdAsValue: boolean = false;
  @Input() useStringValue: boolean = false;
  @Input() visaTypes: IVisaType[] | null = null;

  isPersonOptions(options: OptionItem[] | PersonOption[] | null): options is PersonOption[] {
    return !!options && options.some(option => option.value instanceof Person);
  }

compareWith = (a: any, b: any): boolean => {
  if (this.lookupItems != null && !this.useLookupIdAsValue && !this.useStringValue) {
    return a?.id === b?.id;
  }
  if (this.options != null && !this.isPersonOptions(this.options)&& !this.useLookupIdAsValue && !this.useStringValue) {
    return a?.value === b?.value;
  }
  if (this.visaTypes != null) {
    return a?.id === b?.id;
  }
  return a === b;
};

  getValue(option: any): any {
   
    if(this.useStringValue){
        return option.value;
    }
    if(this.useLookupIdAsValue){
        return option.id;
    }
    if(this.isPersonOptions(this.options)){
      return option.value;
    }

    return option;
     
    }

}
